import type { FC } from 'react';

import {
    Backdrop,
    BottomFour,
    BottomLine,
    BottomOne,
    BottomThree,
    BottomTwo,
    Container,
    Logo,
    MiddleLine,
    TopLine,
} from './styles';

export type MainSpinnerProps = {
    position?: 'fixed' | 'absolute';
    spinnerTopPosition?: number;
};

const MainSpinner: FC<MainSpinnerProps> = ({ position = 'fixed', spinnerTopPosition }) => (
    <>
        <Backdrop position={position} aria-label="Loading" role="status" />
        <Container position={position} spinnerTopPosition={spinnerTopPosition}>
            <Logo>
                <TopLine />
                <MiddleLine />
                <BottomLine>
                    <BottomOne />
                    <BottomTwo />
                    <BottomThree />
                    <BottomFour />
                </BottomLine>
            </Logo>
        </Container>
    </>
);

export default MainSpinner;
